export const navigationData = [
  {
    key: 'home',
    title: '首页',
    path: '/',
  },
  {
    key: 'products',
    title: '产品服务',
    path: '/products',
    children: [
      {
        key: 'system',
        title: '系统产品',
        path: '/products/system',
        description: '服务过程管理ITSM、态势监控平台IDCB、培训认证管理TCMS、数据治理系统MeinnDM'
      },
      { key: 'operation', title: '运行维护', path: '/products/operation', description: '基础设施、服务器存储、操作系统、虚拟化平台、数据库、容器云、云平台、应用系统、安全服务、终端、会议、网络等一站式运维服务'},
      { key: 'hardware', title: '硬件维保', path: '/products/hardware', description: '第三方硬件、系统维保服务'},
      { key: 'innovation', title: '信创服务', path: '/products/innovation', description: '系统集成、迁移与适配、信创运维'},
      { key: 'data', title: '数据治理', path: '/products/data', description: '数据治理'},
      { key: 'custom', title: '应用定制', path: '/products/custom', description: '应用开发、网站及小程序开发'},
      { key: 'enterprise', title: '企业数字化服务', path: '/products/enterprise', description: '通用型办公协同服务、本地化专属办公协同服务、政务领域专用协同办公服务'}
    ]
  },
  {
    key: 'solutions',
    title: '解决方案',
    path: '/solutions',
    children: [
      
      {
        key: 'operation',
        title: '运行维护服务方案',
        path: '/solutions/operation',
        description: '为企业提供专业的运维服务解决方案'
      },
      { key: 'hardware', title: '硬件维保服务方案', path: '/solutions/hardware', description: '专业的硬件维保服务，确保设备稳定运行'},
      { key: 'data', title: '数据治理服务方案', path: '/solutions/data', description: '一站式数据治理解决方案，助力数字化转型'},
      { key: 'enterprise', title: '企业数字化服务解决方案', path: '/solutions/enterprise', description: '企业数字化转型整体解决方案'}
    ]
  },
  {
    key: 'about',
    title: '关于美音',
    path: '/about',
    children: [
      {
        key: 'company-intro',
        title: '公司介绍',
        path: '/about#company-intro'
      },
      {
        key: 'company-culture',
        title: '企业文化',
        path: '/about#company-culture'
      },
      {
        key: 'company-partners',
        title: '合作伙伴',
        path: '/about#company-partners'
      },
      {
        key: 'company-contact',
        title: '联系我们',
        path: '/about#company-contact'
      },
      {
        key: 'news',
        title: '新闻动态',
        path: '/news'
      }
    ]
  }
]; 